import { render, staticRenderFns } from "./WorkflowFolderCollaboratorFilter.vue?vue&type=template&id=f48844b4&scoped=true"
import script from "./WorkflowFolderCollaboratorFilter.vue?vue&type=script&lang=js"
export * from "./WorkflowFolderCollaboratorFilter.vue?vue&type=script&lang=js"
import style0 from "./WorkflowFolderCollaboratorFilter.vue?vue&type=style&index=0&id=f48844b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48844b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VProgressCircular,VTextField})
